import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import Cookies from 'js-cookie';
 

export const fetchData = createAsyncThunk("data/fetchData", async () => {
    const currentUserId = Cookies.get('userId');

    const apiService = new ApiService(`${BASE_URL}/get_user_access/${currentUserId}`, {}, 'GET');
    const res=apiService.makeCall();
    return res; // Return API response
}); 

export const fetchOrgData = createAsyncThunk("data/fetchOrgData", async () => {
  const orgId = Cookies.get('orgId');
  console.log('orgidd',orgId);
  const apiService = new ApiService(`${BASE_URL}/org_infos/${orgId}`, {}, 'GET');
  const res=apiService.makeCall();
  console.log('api res for org:',res);
  return res; // Return API response
}); 

export const fetchUserCurrency = createAsyncThunk("data/fetchOrgData", async () => {
  const orgId = Cookies.get('orgId');
  console.log('orgidd',orgId);
  const apiService = new ApiService(`${BASE_URL}/org_infos/${orgId}`, {}, 'GET');
  const res=apiService.makeCall();
  console.log('api res for org:',res);
  return res; // Return API response
}); 

const dataSlice = createSlice({
  name: "data",
  initialState: {
    items: [], // Empty array (this will store API data)
    orgItem: [],
    status: "idle", // Can be 'idle', 'loading', 'succeeded', or 'failed'
    orgStatus: "idle",
    error: null,
    orgError: null,
  },
  reducers: {}, // No manual reducers needed

  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = "loading"; // When API call starts
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = "succeeded"; // When API call is successful
        state.items = action.payload; // Store API response in Redux
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = "failed"; // If API call fails
        state.error = action.error.message;
      })
      .addCase(fetchOrgData.pending, (state) => {
        state.orgStatus = "loading";
      })
      .addCase(fetchOrgData.fulfilled, (state, action) => {
        state.orgStatus = "succeeded";
        state.orgItem = action.payload;
      })
      .addCase(fetchOrgData.rejected, (state, action) => {
        state.orgStatus = "failed";
        state.orgError = action.error.message;
      });
  },
});

export default dataSlice.reducer;
